import {
  IconButton,
  InputAdornment,
  TextField,
  styled,
  useTheme,
} from "@mui/material";
import { PreviewCloseOne, PreviewOpen } from "assets/Icon";

import { useState } from "react";

function PasswordField(props) {
  const theme = useTheme();
  const [isShowPassword, setIsShowPassword] = useState(false);

  return (
    <TextField
      type={isShowPassword ? "text" : "password"}
      dir="ltr"
      InputProps={{
        startAdornment: (
          <InputAdornment position="end">
            <IconButtonStyle onClick={() => setIsShowPassword(!isShowPassword)}>
              {isShowPassword ? (
                <PreviewOpen color={theme.palette.text.main} />
              ) : (
                <PreviewCloseOne color={theme.palette.text.main} />
              )}
            </IconButtonStyle>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
}

const IconButtonStyle = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.main,
}));

export default PasswordField;
